import { galleryLeftButton, galleryRightButton } from '@project/theme-buttons'


export const homePageNewsClipRow = {
    // outerContainerStyle,
    // innerContainerStyle,
    outerContainerClasses: "fbicc-homepage-news-item-container",
    publishClasses: "fbicc-homepage-newsclip-publish",
    linkClasses: "fbicc-homepage-newsclip-link",
    imageContainerClasses: "fbicc-homepage-newsclip-image-container",
    htmlClasses: "fbicc-homepage-newsclip-html"
}

